// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"28b38759","287":"1d8f2f87","360":"766d2df7","408":"776a1194","482":"2da24049","501":"3538a9ba","636":"f70ad327","683":"e8b3bdc7","885":"920bf2c2"}[chunkId] + ".chunk.js";
};